import axios from 'axios';
import {_requests, _login} from '../configuration/index.config';
import {storageService} from './storageService';
const {UrlDev, GET_REQ, POST_REQ, CORE_PATH, AUTO_CLASSIFICATION_PATH, MANAGE_PATH, DATA_MANAGEMENT_PATH, TAGGING, TRAINING, DEPLOY, EVALUATION_PATH, SAML_PATH} = _requests;
const {TOKEN_EXPIRED} = _login;

const API_URL = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.FIRST_ROUTE}`;
const API_URL_LOGIN = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.LOGIN_ROUTE}`;
const API_URL_MANAGE = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.MANAGEMENT_ROUTE}`;
const API_URL_VIDEOS = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.VA_ROUTE}`;
const API_URL_DATA_MANAGEMENT = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.DATA_MANAGEMENT_ROUTE}`;
const API_URL_CLASSIFICATION = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.CLASSIFICATION_ROUTE}`;
const API_URL_TAGGING = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.TAGGING_ROUTE}`;
const API_URL_TRAINING = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.TRAINING_ROUTE}`;
const API_URL_DEPLOY = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.DEPLOY}`;
const API_URL_EVALUATION = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.EVALUATION}`;
const API_URL_AUTO_CLASSIFICATION = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.AUTOMATED_MODELS}`;
const API_URL_SAML = `${UrlDev.SSL}${UrlDev.SIA_API_HOST}/${UrlDev.SAML}`;
const GET_TOKEN = `${API_URL_LOGIN}/get_token/`;

class Request {
    private setExpireToken = () => {};
    private ANALYZE_TOKEN = '';
    constructor() {
        this.setMiddleware();
    }

    findRoute = (isVideo, isClassification, reqName) => {
        if (isVideo) {
            return API_URL_VIDEOS;
        } else if (isClassification) {
            return API_URL_CLASSIFICATION;
        } else if (CORE_PATH[reqName]) {
            return API_URL_LOGIN;
        } else if (MANAGE_PATH[reqName]) {
            return API_URL_MANAGE;
        } else if (DATA_MANAGEMENT_PATH[reqName]) {
            return API_URL_DATA_MANAGEMENT;
        } else if (TAGGING[reqName]) {
            return API_URL_TAGGING;
        } else if (TRAINING[reqName]) {
            return API_URL_TRAINING;
        } else if (DEPLOY[reqName]) {
            return API_URL_DEPLOY;
        } else if (EVALUATION_PATH[reqName]) {
            return API_URL_EVALUATION;
        } else if (AUTO_CLASSIFICATION_PATH[reqName]) {
            return API_URL_AUTO_CLASSIFICATION;
        } else if (SAML_PATH[reqName]) {
            return API_URL_SAML;
        }

        return API_URL;
    }

    /**
     * setAnalyzeToken - set token analyze
     * @param analyzeToken - jwt token
     */
    setAnalyzeToken = (analyzeToken) => this.ANALYZE_TOKEN = analyzeToken;

    /**
     * setMiddleware - check if token expire on all the responses
     */
    setMiddleware = () => {
        axios.interceptors.response.use((response) => response, async (error) => {
            error.response && error.response.data.detail === TOKEN_EXPIRED && this.setExpireToken();

            return Promise.reject(error);
        });
    }

    /**
     * sendBeacon - send Beacon (synchronic request)
     * @param reqName - request name (taken from GET_REQ list)
     * @param reqData - request data
     * @param isVideo - if request is for video path
     * @param isClassification - if request is for path
     */
    sendBeacon = (reqName, reqData, isVideo = false, isClassification = false) => {
        const API = this.findRoute(isVideo, isClassification, reqName);
        const data = new FormData();

        Object.keys(reqData).forEach((key) => data.append(key, reqData[key]));
        navigator.sendBeacon(`${API}/${POST_REQ[reqName]}`, JSON.stringify(reqData));
    }

    /**
     * setExpireToken - setExpireToken function
     * @param setExpireToken - function
     */
    setIsExpireToken = (setExpireToken) => this.setExpireToken = setExpireToken;

    /**
     * getToken - create token on first time
     */
    async getToken(username, password) {
        const user = {username, password};

        return await axios.post(GET_TOKEN, user);
    }

    /**
     * put - all the put requests in the app
     * @param url - url for third party
     * @param file - file send in request
     * @param headers - headers
     */
    async put(url, file, headers) {
        return await axios.put(url, file, {headers});
    }

    /**
     * get - all the get requests in the app
     * @param token - user token
     * @param reqName - request name (taken from GET_REQ list)
     * @param param - get param
     * @param isVideo - if request is for video path
     * @param isClassification - if request is for path
     */
    async get(token, reqName, isVideo, param, isClassification = false) {
        const headers = token ? {Authorization: `Token ${token}`} : {};
        const API = this.findRoute(isVideo, isClassification, reqName);

        return param.length === 0 ? await axios.get(`${API}/${GET_REQ[reqName]}`, {headers}) : await axios.get(`${API}/${GET_REQ[reqName]}${param}/`, {headers});
    }

    /**
     * get - all the get requests in the app
     * @param token - user token
     * @param reqName - request name (taken from GET_REQ list)
     * @param multiParam - get params
     * @param isVideo - if request is for video path
     * @param isClassification - if request is for path
     */
    async getMultiParam(token, reqName, isVideo, multiParam, isClassification = false) {
        const headers = token ? {Authorization: `Token ${token}`} : {};
        const API = this.findRoute(isVideo, isClassification, reqName);
        let params = '';

        multiParam.forEach((param) => param.length > 0 && (params += `${param}/`));

        return params.length === 0 ? await axios.get(`${API}/${GET_REQ[reqName]}`, {headers}) : await axios.get(`${API}/${GET_REQ[reqName]}${params}`, {headers});
    }

    /**
     * post - all the post requests in the app
     * @param token - user token
     * @param reqName - request name (taken from GET_REQ list)
     * @param data - data body
     * @param isVideo - if request is for video
     * @param isClassification - if request is for path
     */
    async post(token, reqName, data, isVideo = false, isClassification = false) {
        const headers = token ? {Authorization: `Token ${token}`} : {};
        const API = this.findRoute(isVideo, isClassification, reqName);

        return await axios.post(`${API}/${POST_REQ[reqName]}`, data, {headers});
    }

    /**
     * sendJsonsToS3 - send jsons to S3
     * @param json - json data and json name
     * @param projectName - project Name
     */
    async sendJsonsToS3(json: any, projectName): Promise<any> {
        const token = storageService.loadFromStorage('token');

        const headers = {
            'Content-Type': 'application/octet-stream',
            'x-amz-acl': 'bucket-owner-full-control'
        };

        const postSignedData = {
            'upload_type': 'upload_tag',
            'project_name': projectName,
            'file_names': [json.name]
        };

        return this.post(token, 'GET_SIGNED', postSignedData).then((res) => {
            const url = res.data.signed_urls[0];

            return axios.put(url, json.data, {headers});
        });
    }

    /**
     * sendImagesToS3 - send images to S3
     * @param image - image base64, image name
     * @param projectName - project Name
     */
    async sendImagesToS3(image: any, projectName): Promise<any> {
        const token = storageService.loadFromStorage('token');

        const headers = {
            'Content-Type': 'application/octet-stream',
            'x-amz-acl': 'bucket-owner-full-control'
        };
        const postSignedData = {
            'upload_type': 'upload_tag',
            'project_name': projectName,
            'file_names': [image.name]
        };

        return this.post(token, 'GET_SIGNED', postSignedData).then((res) => {
            const url = res.data.signed_urls[0];

            const bufferData = Buffer.from(image.img.split(',')[1], 'base64');

            return axios.put(url, bufferData, {headers});
        });
    }

    /**
     * sendVideoToS3 - send video to S3
     * @param video - video blob, video name
     * @param projectName - project Name
     * @param isClassification - find if in classification api
     */
    async sendVideoToS3(video: any, projectName, isClassification): Promise<any> {
        const token = storageService.loadFromStorage('token');

        const headers = {
            'Content-Type': 'application/octet-stream',
            'x-amz-acl': 'bucket-owner-full-control'
        };
        const postSignedData = {
            'upload_type': isClassification ? 'upload_vid' : 'upload_train',
            'project_name': projectName,
            'file_names': [video.name],
            'class_name': video.folderName
        };

        return this.post(token, 'GET_SIGNED_VIDEOS', postSignedData, !isClassification, isClassification).then((res) => {
            const url = res.data.signed_urls[0];

            return axios.put(url, video.blob, {headers});
        });
    }

    /**
     * setFaceRecognitionBody - set face recognition body (analyze api)
     * @param data - request data
     */
    setFaceRecognitionBody(data) {

        return {
            inputImages: data.inputImages,
            token: this.ANALYZE_TOKEN,
            featureName: data.featureOptions,
            featureOptions: {
                'annotationImageOptions': {
                    'fetchAnnotatedImage': true,
                    'annotationLanguage': 'en'
                },
                'faceDetectionOptions': {'returnFaces': true}
            }
        };
    }

    /**
     * sendAnalyzeRequest - send analyze request
     * @param data - {type - analyze type, inputImages: list of images, featureOptions: more request options}
     */
    async sendAnalyzeRequest(data:{type:string, inputImages?:string[], featureOptions?:string}) {
        const analyseType = data.type;

        if (analyseType === 'faceRecognition') {
            const body = this.setFaceRecognitionBody(data);

            return await axios.post(`${UrlDev.ANALYZE}/public/analyze`, body);
        }
    }
}

export const request = new Request();
